import { Box, Button, DialogContent, Grid, Typography } from '@mui/material';
import { FC, ReactNode } from 'react';

import { Dialog } from '../../components/dialog';

type Props = {
  content: ReactNode;
  onClose?: () => void;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  primaryActionLabel: string;
  secondaryActionLabel: string;
  title: string;
};

const ActionDlg: FC<Props> = ({
  content,
  onClose,
  onPrimaryAction,
  onSecondaryAction,
  primaryActionLabel,
  secondaryActionLabel,
  title,
}: Props) => {
  return (
    <Dialog title={title} open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent dividers>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="subtitle1" align="center">
              {content}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Button color="primary" size="large" fullWidth onClick={onPrimaryAction} type="button" variant="contained">
              {primaryActionLabel}
            </Button>
            <Box mt={1}>
              <Button size="large" onClick={onSecondaryAction} fullWidth>
                {secondaryActionLabel}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export { ActionDlg };
